import 'COMMON';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Bem/site/faq-accordion/faq-accordion';
import 'Lib/js-anchor-link/js-anchor-link';
import 'Bem/site/ajax-form/ajax-form';
import 'Bem/site/mail-form/mail-form';
import 'Bem/site/checkbox-accept/checkbox-accept';

svgSpriteLoader('/site/faq/svg/sprite.svg?v=20180320');